module.exports = __webpack_public_path__ + "static/media/chassis.8795a05e.png";